import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse, User } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

interface UpdateProfileData {
  name: string;
  email?: string;
  fullAddress?: string;
  mobilePhone?: string;
  phone?: string;
  smsReceive: boolean;
}

export const useUpdateProfile = ({ userId }: { userId: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.users.updateProfile],
    mutationFn: async (userData: UpdateProfileData): Promise<User> => {
      const response = await XHRAuthorizedClient.put<ApiResponse<User>>(
        ENDPOINTS.users.update(userId),
        userData
      );
      return response.data.data;
    },
    onSuccess: () => {
      // 현재 사용자 정보와 유저 리스트를 모두 무효화
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('프로필 업데이트 오류:', error);
    },
  });
};
